import moment from "moment";

export default {
    data() {
        return {
            isObject(item) {
                return (item && typeof item === 'object' && !Array.isArray(item));
            },
            pagePreviewLink(item) {
                return '/' + item.slug;
            },
            postPreviewLink(item) {
                return '/posts/' + item.slug;
            },
            eventPreviewLink(item) {
                return '/events/' + item.slug;
            },
            formatDate(date, format) {
                return date ? moment(date, format).format('MM/DD/YYYY') : '';
            },
            formatMoney(value) {
                return parseFloat(value).toLocaleString('en-US', {
                    style: 'decimal',
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                });
            },
            mergeDeep(target, ...sources) {
                if (!sources.length) return target;
                const source = sources.shift();

                if (this.isObject(target) && this.isObject(source)) {
                    for (const key in source) {
                        if (this.isObject(source[key])) {
                            if (!target[key]) Object.assign(target, {[key]: {}});
                            this.mergeDeep(target[key], source[key]);
                        } else {
                            Object.assign(target, {[key]: source[key]});
                        }
                    }
                }

                return this.mergeDeep(target, ...sources);
            },
            strToLat(str) {
                str = str.toLowerCase();

                const cyr_2_lat_chars = new Array(
                    ['а', 'a'], ['б', 'b'], ['в', 'v'], ['г', 'g'],
                    ['д', 'd'],  ['е', 'e'], ['ё', 'yo'], ['ж', 'zh'], ['з', 'z'],
                    ['и', 'i'], ['й', 'y'], ['к', 'k'], ['л', 'l'],
                    ['м', 'm'],  ['н', 'n'], ['о', 'o'], ['п', 'p'],  ['р', 'r'],
                    ['с', 's'], ['т', 't'], ['у', 'u'], ['ф', 'f'],
                    ['х', 'h'],  ['ц', 'c'], ['ч', 'ch'],['ш', 'sh'], ['щ', 'shch'],
                    ['ъ', ''],  ['ы', 'y'], ['ь', ''],  ['э', 'e'], ['ю', 'yu'], ['я', 'ya'],

                    ['А', 'A'], ['Б', 'B'],  ['В', 'V'], ['Г', 'G'],
                    ['Д', 'D'], ['Е', 'E'], ['Ё', 'YO'],  ['Ж', 'ZH'], ['З', 'Z'],
                    ['И', 'I'], ['Й', 'Y'],  ['К', 'K'], ['Л', 'L'],
                    ['М', 'M'], ['Н', 'N'], ['О', 'O'],  ['П', 'P'],  ['Р', 'R'],
                    ['С', 'S'], ['Т', 'T'],  ['У', 'U'], ['Ф', 'F'],
                    ['Х', 'H'], ['Ц', 'C'], ['Ч', 'CH'], ['Ш', 'SH'], ['Щ', 'SHCH'],
                    ['Ъ', ''],  ['Ы', 'Y'],
                    ['Ь', ''],
                    ['Э', 'E'],
                    ['Ю', 'YU'],
                    ['Я', 'YA'],

                    ['a', 'a'], ['b', 'b'], ['c', 'c'], ['d', 'd'], ['e', 'e'],
                    ['f', 'f'], ['g', 'g'], ['h', 'h'], ['i', 'i'], ['j', 'j'],
                    ['k', 'k'], ['l', 'l'], ['m', 'm'], ['n', 'n'], ['o', 'o'],
                    ['p', 'p'], ['q', 'q'], ['r', 'r'], ['s', 's'], ['t', 't'],
                    ['u', 'u'], ['v', 'v'], ['w', 'w'], ['x', 'x'], ['y', 'y'],
                    ['z', 'z'],

                    ['A', 'A'], ['B', 'B'], ['C', 'C'], ['D', 'D'],['E', 'E'],
                    ['F', 'F'],['G', 'G'],['H', 'H'],['I', 'I'],['J', 'J'],['K', 'K'],
                    ['L', 'L'], ['M', 'M'], ['N', 'N'], ['O', 'O'],['P', 'P'],
                    ['Q', 'Q'],['R', 'R'],['S', 'S'],['T', 'T'],['U', 'U'],['V', 'V'],
                    ['W', 'W'], ['X', 'X'], ['Y', 'Y'], ['Z', 'Z'],

                    [' ', '-'],['0', '0'],['1', '1'],['2', '2'],['3', '3'],
                    ['4', '4'],['5', '5'],['6', '6'],['7', '7'],['8', '8'],['9', '9'],
                    ['-', '-'],['_', '_']
                );

                let lat_str = new String();

                for (let i = 0; i < str.length; i++) {
                    const char = str.charAt(i);
                    let lat_char = '';

                    for (let j = 0; j < cyr_2_lat_chars.length; j++) {
                        if (char == cyr_2_lat_chars[j][0]) {
                            lat_char = cyr_2_lat_chars[j][1];
                        }
                    }

                    lat_str += lat_char;
                }

                return lat_str;
            },
            generateSlug(str) {
                const lat_str = this.strToLat(str);

                return lat_str
                    .replace(/[_]{2,}/gim, '_')
                    .replace(/\n/gim, '')
                    .split('-')
                    .filter(function(value, i, arr){
                        return value.trim('-');
                    })
                    .join('-');
            },
            generateFieldName(str) {
                const lat_str = this.strToLat(str);

                return lat_str
                    .replace(/[_]{2,}/gim, '_')
                    .replace(/\n/gim, '')
                    .split('-')
                    .filter(function(value, i, arr){
                        return value.trim('-');
                    })
                    .join('_');
            }
        }
    }
}
